import _ from 'lodash';

export type DataValue = string | number | boolean | object;

const updateLocalDataObject = <T>(changes: {
  value: DataValue;
  key: string;
}[], dataObject: T): T => {
  if (!dataObject) {
    return dataObject;
  }

  const newDataObject = _.cloneDeep(dataObject) as T;
  changes.forEach(({ value, key }) => {
    if (typeof key !== 'string') {
      return;
    }
    const keys = key.split('.');
    let currentObject: T = newDataObject;
    for (let i = 0; i < keys.length - 1; i += 1) {
      const currentKey = keys[i];
      if (!currentObject[currentKey] || typeof currentObject[currentKey] !== 'object') {
        currentObject[currentKey] = {};
      }
      currentObject = currentObject[currentKey];
    }

    const lastKey = keys[keys.length - 1];
    currentObject[lastKey] = value;
  });
  return newDataObject;
};

export default updateLocalDataObject;
